import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { filter, map, shareReplay, switchMap } from 'rxjs/operators';
import { AuthService, shareReplayRefCount, StateService } from '@adreno-common';
import { GetUserProfileVm, UserProfile } from '../models';

@Injectable({
  providedIn: 'root',
})
export class UserProfileService extends StateService<State> {
  private usersApi = `${environment.apiPath}/users`;

  userProfile$: Observable<UserProfile>;

  constructor(private http: HttpClient, authSvc: AuthService) {
    super(initalState);
    this.userProfile$ = authSvc.userId$.pipe(
      filter((userId) => !!userId),
      map((userId) => userId!),
      switchMap((userId) =>
        this.select(
          (state, userId) => state.profiles[userId],
          () => this.loadProfile(userId),
          userId
        )
      )
    );
  }

  private loadProfile(userId: number) {
    this.http
      .get<GetUserProfileVm>(`${this.usersApi}/${userId}/profile`)
      .pipe(shareReplayRefCount())
      .subscribe(
        (up) =>
          (this.state = {
            profiles: {
              ...this.state.profiles,
              [userId]: {
                ...(this.state.profiles[userId] || {}),
                ...up,
              },
            },
          })
      );
  }

  clickToCall() {
    this.http.get(`${this.usersApi}/clicktocalloffice`, {}).subscribe();
  }

  toggleDarkMode() {
    this.http.post(`${this.usersApi}/toggledarkmode`, {}).subscribe();
  }
}

interface State {
  profiles: { [userId: number]: UserProfile };
}

const initalState: State = {
  profiles: {},
};
